$( document ).ready(function() {


  $('.js-qty__adjust--minus').on('change keyup click', function() {
    if($(this.closest(".js-qty__wrapper")).find("input.js-qty__num").val()  == 1){
      $(this).addClass("disabled");
    } 
  });

  $('.js-qty__adjust--plus').on('change keyup click', function() {
    if($(this.closest(".js-qty__wrapper")).find("input.js-qty__num").val() > 1){
      $('.js-qty__adjust--minus').removeClass("disabled");
    } 
  });
  

  $('.Logolist__Slider .new-grid').slick({
    adaptiveHeight: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:`<button type='button' class='slick-prev pull-left'><svg width="35" height="13" viewBox="0 0 35 13"><g><g><image width="35" height="13" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAANCAYAAAAjf9cfAAAAAXNSR0IArs4c6QAAATBJREFUSEtjZMACpk2bllhZWVn/4MEDA0FBwQ/Y1NBCjBHd0ClTpsTn5OTMDQwMXLdu3boIRkbGf7SwGJuZKI6ZPXt2ZGpq6mJvb+8tW7ZsCWFkZPxDL4eA7IE7BuqQhd7e3tu2bNkSzsjI+JOeDoE7ZqBDBOZpxiVLlgTGxMSsEBISer548eIMLi6uH/QOEZB9IiIiLxm5uLheffv2TXQgHIBsJwcHx0vGAwcOODo7O2/h5+d/vXr16igREZFPA+Ewfn7+t+AEvG3bNk9vb+8NNjY2xw4dOuTFyMj4fSAcBM9NIAf5+Pissba2PrV27VpfMTGxL/R2EEo5M9AhhFECb9y40S8gIGC1o6Pjwb1794KijG4FH4ZjQFGzcuXKsIyMjI779+8bCwgIvKdXdAEAmFVwaVNhRP8AAAAASUVORK5CYII="/></g></g></svg></button>`,
    nextArrow:`<button type='button' class='slick-next pull-right'><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="35" height="13" viewBox="0 0 35 13"><g><g><image width="35" height="13" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAANCAYAAAAjf9cfAAAAAXNSR0IArs4c6QAAASZJREFUSEtjZKAjeP/+vYCCgsKF9vb2xqysrPnoVjPS0S0M////ZwoKClqxfv36oClTpiTn5OQsRLafro4BWfz//38WHx+fNVu3bvWZPXt2bGpq6nKYg+juGKiD2H18fFZu3brVa/bs2fEwBw2IY3CFEOPly5c137x5I07PtAOz69u3bxyxsbEz3r17J7lkyZIIRg4Ojhc/fvwYEMcgBwAXF9drxgcPHkh+/PhReCBC5s2bN3yhoaHLPn78KLp3716fgUwznHZ2dtuOHDlitXXr1gAvL6/tA+KYV69e8QQHB28+evSo2ZYtW0JADgHFDN0d8///f4wQGZByBlTgOTs7b9u/f7/9hg0bQv39/TcNWAn84cMHQUVFxbMzZsyoCA8PX4WeaQBWUIvUDK0fQwAAAABJRU5ErkJggg=="/></g></g></svg></button>`,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.text-column-section .rte-title').matchHeight();
  $('.text-column-section .grid__item').matchHeight();

  $(document).on('click','.variant-button', function() {
    var get_name = $(this).attr('data-name');
    $('.variant-wrapper').find('[data-swatch-name="' + get_name + '"]').addClass('model-open')
  });

  $(document).on('click','.close-btn', function() {
    $('.custom-model-main').removeClass('model-open')
  });

  $(document).click(function(event) {
     if (!$(event.target).closest(".custom-model-inner,.variant-button").length) {
      $("body").find(".custom-model-main").removeClass("model-open");
    }
  }) 


  $(document).on('click','#RecoverPassword', function() {
    $('.main-content').addClass('hide_login')
  });
  $(document).on('click','#HideRecoverPasswordLink', function() {
    $('.main-content').removeClass('hide_login')
  });


  
});

if(document.querySelectorAll('.js-more-option-col')){
document.querySelectorAll('.js-more-option-col').forEach(function(event){
  event.addEventListener('click',function(item){
      let id = item.target.getAttribute('data-product-id');
      document.querySelector(`.js-more-option-select-col[data-product-id="${id}"]`).classList.remove('hide');
      item.target.classList.add('hide');
  });
});
}





// Wrap sections in a wrapper.
function wrapSections(section_class) {
  var childSections = document.querySelectorAll("."+section_class);
  if(childSections.length == 0) return;
  var wrapper = document.createElement('div');
  wrapper.classList.add(section_class+"-wrapper");
  childSections.item(0).parentNode.insertBefore(wrapper, childSections.item(0));
  
  for ( var i=0; i< childSections.length; i++){
    wrapper.appendChild(childSections.item(i));
  }
}
// You can call this function with a specific section class.
wrapSections("section-recent-titles");


function dataLayerEvent(_this) {
  let productData = [];
  productData.push(JSON.parse(_this.dataset.productData));
  dataLayer.push({ecommerce: null}); // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: productData
    }
  });
}

// Header's div wrap in another div

// document.addEventListener("DOMContentLoaded", function () {
//   const headerBar = document.getElementById("shopify-section-header-bar");
//   const headerWrapper = document.getElementById("HeaderWrapper");

//   if (headerBar && headerWrapper) {
//     headerWrapper.appendChild(headerBar);
//   }
// });
